type Props = {};
export default function Main({}: Props) {
  return <div>Main App</div>;
}
